import Vue from "vue";
import VueRouter from "vue-router";
import LayoutMain from "../layouts/LayoutMain.vue";
import LayoutConsole from "../layouts/LayoutConsole.vue";

//BOC:[state]
import store from "./../store/index";
//EOC

//BOC:[guard]
import multiguard from "vue-router-multiguard";
const loggedIn = function (to, from, next) {
  if (!store.state.account.data) next({ name: "LoginView" });
  next();
};

const notLoggedIn = function (to, from, next) {
  if (store.state.account.data && store.state.account.data.token) {
    next({ name: "DashboardView" });
  }
  next();
};
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: LayoutMain,
    beforeEnter: multiguard([notLoggedIn]),
    children: [
      {
        path: "",
        name: "LoginView",
        component: () =>
          import(/* webpackChunkName: "login-view" */ "@/views/LoginView.vue"),
        props: true,
      },
    ],
  },
  {
    path: "/",
    component: LayoutConsole,
    beforeEnter: multiguard([loggedIn]),
    props: true,
    children: [
      {
        path: "dashboard",
        name: "DashboardView",
        component: () =>
          import(
            /* webpackChunkName: "dashboard-view" */ "@/views/user/DashboardView.vue"
          ),
        props: true,
        meta: {
          title: "Dashboard",
        },
      },
      {
        path: "calendar",
        name: "CalendarView",
        component: () =>
          import(
            /* webpackChunkName: "dashboard-view" */ "@/views/user/CalendarView.vue"
          ),
        props: true,
        meta: {
          title: "Calendar",
        },
      },
      {
        path: "admins",
        name: "AdminBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "admins-browse-view" */ "@/views/user/AdminBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Admins",
          permission: 2,
        },
      },
      {
        path: "admins/new",
        name: "AdminAddView",
        component: () =>
          import(
            /* webpackChunkName: "admins-add-view" */ "@/views/user/AdminAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Admin",
          permission: 1,
        },
      },
      {
        path: "admins/:uuid",
        name: "AdminReadView",
        component: () =>
          import(
            /* webpackChunkName: "admins-read-view" */ "@/views/user/AdminReadView.vue"
          ),
        props: true,
        meta: {
          title: "Admin Info",
          permission: 2,
        },
      },
      {
        path: "admins/:uuid/edit",
        name: "AdminEditView",
        component: () =>
          import(
            /* webpackChunkName: "admins-edit-view" */ "@/views/user/AdminEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Admin",
          permission: 3,
        },
      },
      {
        path: "admins/:uuid/delete",
        name: "AdminDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "admins-delete-view" */ "@/views/user/AdminDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Admin",
          permission: 4,
        },
      },
      {
        path: "technicians",
        name: "TechnicianBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-browse-view" */ "@/views/user/TechnicianBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Technicians",
          permission: 6,
        },
      },
      {
        path: "technicians/new",
        name: "TechnicianAddView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-add-view" */ "@/views/user/TechnicianAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Technician",
          permission: 5,
        },
      },
      {
        path: "technicians/:uuid",
        name: "TechnicianReadView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-read-view" */ "@/views/user/TechnicianReadView.vue"
          ),
        props: true,
        meta: {
          title: "Technician Info",
          permission: 6,
        },
      },
      {
        path: "technicians/:uuid/edit",
        name: "TechnicianEditView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-edit-view" */ "@/views/user/TechnicianEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Technician",
          permission: 7,
        },
      },
      {
        path: "technicians/:uuid/delete",
        name: "TechnicianDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-delete-view" */ "@/views/user/TechnicianDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Technician",
          permission: 8,
        },
      },
      {
        path: "technicians/:uuid/products/manage",
        name: "TechnicianProductManageView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-product-manage-view" */ "@/views/user/TechnicianProductManageView.vue"
          ),
        props: true,
        meta: {
          title: "Manage Technician Products",
          permission: 8,
        },
      },
      {
        path: "technicians/:uuid/products/import",
        name: "TechnicianProductImportView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-product-import-view" */ "@/views/user/TechnicianProductImportView.vue"
          ),
        props: true,
        meta: {
          title: "Import Technician Products",
          permission: 8,
        },
      },
      {
        path: "transactions",
        name: "WiseTransactionBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "transactions-browse-view" */ "@/views/user/WiseTransactionBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Transactions",
          permission: 39,
        },
      },
      {
        path: "transactions/:uuid",
        name: "WiseTransactionReadView",
        component: () =>
          import(
            /* webpackChunkName: "transactions-read-view" */ "@/views/user/WiseTransactionReadView.vue"
          ),
        props: true,
        meta: {
          title: "Transaction Info",
          permission: 10,
        },
      },
      {
        path: "wise-jars",
        name: "WiseJarBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "wise-jars-browse-view" */ "@/views/user/WiseJarBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Wise Jars",
          permission: 54,
        },
      },
        {
        path: "wise-jars/sync",
        name: "WiseJarSyncView",
        component: () =>
          import(
            /* webpackChunkName: "wise-jars-sync-view" */ "@/views/user/WiseJarSyncView.vue"
          ),
        props: true,
        meta: {
          title: "Sync Jars",
          permission: 53,
        },
      },
      {
        path: "wise-jars/:uuid",
        name: "WiseJarReadView",
        component: () =>
          import(
            /* webpackChunkName: "wise-jars-read-view" */ "@/views/user/WiseJarReadView.vue"
          ),
        props: true,
        meta: {
          title: "Wise Jar Info",
          permission: 54,
        },
      },
      {
        path: "wise-jars/:uuid/edit",
        name: "WiseJarEditView",
        component: () =>
          import(
            /* webpackChunkName: "wise-jars-edit-view" */ "@/views/user/WiseJarEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Wise Jar",
          permission: 55,
        },
      },
      {
        path: "wise-users",
        name: "WiseUserBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "wise-users-browse-view" */ "@/views/user/WiseUserBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Wise Users",
          permission: 39,
        },
      },
       {
        path: "wise-users/sync",
        name: "WiseUserSyncView",
        component: () =>
          import(
            /* webpackChunkName: "wise-users-sync-view" */ "@/views/user/WiseUserSyncView.vue"
          ),
        props: true,
        meta: {
          title: "Sync Users",
          permission: 38,
        },
      },
      {
        path: "wise-users/:uuid",
        name: "WiseUserReadView",
        component: () =>
          import(
            /* webpackChunkName: "wise-users-read-view" */ "@/views/user/WiseUserReadView.vue"
          ),
        props: true,
        meta: {
          title: "Wise User Info",
          permission: 39,
        },
      },
      {
        path: "wise-users/:uuid/edit",
        name: "WiseUserEditView",
        component: () =>
          import(
            /* webpackChunkName: "wise-users-edit-view" */ "@/views/user/WiseUserEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Wise User",
          permission: 40,
        },
      },
      {
        path: "users",
        name: "UserBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "users-browse-view" */ "@/views/user/UserBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Users",
          permission: 10,
        },
      },
      {
        path: "users/new",
        name: "UserAddView",
        component: () =>
          import(
            /* webpackChunkName: "users-add-view" */ "@/views/user/UserAddView.vue"
          ),
        props: true,
        meta: {
          title: "New User",
          permission: 9,
        },
      },
      {
        path: "users/:uuid",
        name: "UserReadView",
        component: () =>
          import(
            /* webpackChunkName: "users-read-view" */ "@/views/user/UserReadView.vue"
          ),
        props: true,
        meta: {
          title: "User Info",
          permission: 10,
        },
      },
      {
        path: "users/:uuid/edit",
        name: "UserEditView",
        component: () =>
          import(
            /* webpackChunkName: "users-edit-view" */ "@/views/user/UserEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit User",
          permission: 11,
        },
      },
      {
        path: "users/:uuid/delete",
        name: "UserDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "users-delete-view" */ "@/views/user/UserDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete User",
          permission: 12,
        },
      },
      {
        path: "activity-logs",
        name: "ActivityLogBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "activity-log-browse-view" */ "@/views/user/ActivityLogBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Activity Logs",
          permission: 17,
        },
      },
      {
        path: "activity-logs/:uuid",
        name: "ActivityLogReadView",
        component: () =>
          import(
            /* webpackChunkName: "activity-log-read-view" */ "@/views/user/ActivityLogReadView.vue"
          ),
        props: true,
        meta: {
          title: "Activity Log Info",
          permission: 17,
        },
      },
      {
        path: "activity-logs/:uuid/delete",
        name: "ActivityLogDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "activity-log-delete-view" */ "@/views/user/ActivityLogDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Activity Log",
          permission: 18,
        },
      },
      {
        path: "countries",
        name: "CountryBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "countries-browse-view" */ "@/views/user/CountryBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Countries",
          permission: 20,
        },
      },
      {
        path: "countries/new",
        name: "CountryAddView",
        component: () =>
          import(
            /* webpackChunkName: "countries-add-view" */ "@/views/user/CountryAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Country",
          permission: 19,
        },
      },
      {
        path: "countries/:uuid",
        name: "CountryReadView",
        component: () =>
          import(
            /* webpackChunkName: "countries-read-view" */ "@/views/user/CountryReadView.vue"
          ),
        props: true,
        meta: {
          title: "Country Info",
          permission: 20,
        },
      },
      {
        path: "countries/:uuid/delete",
        name: "CountryDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "countries-delete-view" */ "@/views/user/CountryDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Country",
          permission: 21,
        },
      },
      {
        path: "deals",
        name: "DealBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "deals-browse-view" */ "@/views/user/DealBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Deals",
          permission: 37,
        },
      },
      {
        path: "deals/:uuid",
        name: "DealReadView",
        component: () =>
          import(
            /* webpackChunkName: "deals-read-view" */ "@/views/user/DealReadView.vue"
          ),
        props: true,
        meta: {
          title: "Deal Info",
          permission: 37,
        },
      },
      {
        path: "locations",
        name: "LocationBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "locations-browse-view" */ "@/views/user/LocationBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Locations",
          permission: 27,
        },
      },
      {
        path: "locations/new",
        name: "LocationAddView",
        component: () =>
          import(
            /* webpackChunkName: "locations-add-view" */ "@/views/user/LocationAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Location",
          permission: 26,
        },
      },
      {
        path: "locations/:uuid",
        name: "LocationReadView",
        component: () =>
          import(
            /* webpackChunkName: "locations-read-view" */ "@/views/user/LocationReadView.vue"
          ),
        props: true,
        meta: {
          title: "Location Info",
          permission: 27,
        },
      },
      {
        path: "locations/:uuid/edit",
        name: "LocationEditView",
        component: () =>
          import(
            /* webpackChunkName: "locations-edit-view" */ "@/views/user/LocationEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Location",
          permission: 28,
        },
      },
      {
        path: "locations/:uuid/delete",
        name: "LocationDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "locations-delete-view" */ "@/views/user/LocationDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Product",
          permission: 29,
        },
      },
      {
        path: "products",
        name: "ProductBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "products-browse-view" */ "@/views/user/ProductBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Products",
          permission: 23,
        },
      },
      {
        path: "products/:uuid",
        name: "ProductReadView",
        component: () =>
          import(
            /* webpackChunkName: "products-read-view" */ "@/views/user/ProductReadView.vue"
          ),
        props: true,
        meta: {
          title: "Product Info",
          permission: 23,
        },
      },
      {
        path: "products/:uuid/edit",
        name: "ProductEditView",
        component: () =>
          import(
            /* webpackChunkName: "products-edit-view" */ "@/views/user/ProductEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Product",
          permission: 24,
        },
      },
      {
        path: "products/:uuid/delete",
        name: "ProductDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "products-delete-view" */ "@/views/user/ProductDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Product",
          permission: 25,
        },
      },
      {
        path: "admin-invoices",
        name: "AdminInvoiceBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-browse-view" */ "@/views/user/AdminInvoiceBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Invoices",
          permission: 34,
        },
      },
      {
        path: "admin-invoices/:uuid",
        name: "AdminInvoiceReadView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-read-view" */ "@/views/user/AdminInvoiceReadView.vue"
          ),
        props: true,
        meta: {
          title: "Invoice Info",
          permission: 34,
        },
      },
      {
        path: "admin-invoices/:uuid/reject",
        name: "AdminInvoiceRejectView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-reject-view" */ "@/views/user/AdminInvoiceRejectView.vue"
          ),
        props: true,
        meta: {
          title: "Reject Invoice",
          permission: 36,
        },
      },
      {
        path: "admin-invoices/:uuid/approve",
        name: "AdminInvoiceApproveView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-approve-view" */ "@/views/user/AdminInvoiceApproveView.vue"
          ),
        props: true,
        meta: {
          title: "Approve Invoice",
          permission: 35,
        },
      },
      {
        path: "admin-invoices/:uuid/pay",
        name: "AdminInvoicePayView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-pay-view" */ "@/views/user/AdminInvoicePayView.vue"
          ),
        props: true,
        meta: {
          title: "Pay Invoice",
          permission: 35,
        },
      },
      {
        path: "invoices",
        name: "InvoiceBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "invoices-browse-view" */ "@/views/user/InvoiceBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Invoices",
          permission: 31,
        },
      },
      {
        path: "invoices/new",
        name: "InvoiceAddView",
        component: () =>
          import(
            /* webpackChunkName: "invoices-add-view" */ "@/views/user/InvoiceAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Invoice",
          permission: 30,
        },
      },
      {
        path: "orders",
        name: "OrderBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "orders-browse-view" */ "@/views/user/OrderBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Orders",
          permission: 43,
        },
      },
      {
        path: "orders/new",
        name: "OrderAddView",
        component: () =>
          import(
            /* webpackChunkName: "orders-add-view" */ "@/views/user/OrderAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Order",
          permission: 42,
        },
      },
      {
        path: "orders/:uuid",
        name: "OrderReadView",
        component: () =>
          import(
            /* webpackChunkName: "orders-read-view" */ "@/views/user/OrderReadView.vue"
          ),
        props: true,
        meta: {
          title: "Order Info",
          permission: 43,
        },
      },
      {
        path: "customers",
        name: "CustomerBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "customers-browse-view" */ "@/views/user/CustomerBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Customers",
          permission: 14,
        },
      },
      {
        path: "customers/:uuid",
        name: "CustomerReadView",
        component: () =>
          import(
            /* webpackChunkName: "customers-read-view" */ "@/views/user/CustomerReadView.vue"
          ),
        props: true,
        meta: {
          title: "Customer Info",
          permission: 20,
        },
      },
      {
        path: "utils",
        name: "UtilBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "utils-browse-view" */ "@/views/user/UtilBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Utils",
          permission: 46,
        },
      },
      {
        path: "utils/new",
        name: "UtilAddView",
        component: () =>
          import(
            /* webpackChunkName: "utils-add-view" */ "@/views/user/UtilAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Util",
          permission: 45,
        },
      },
      {
        path: "utils/:uuid",
        name: "UtilReadView",
        component: () =>
          import(
            /* webpackChunkName: "utils-read-view" */ "@/views/user/UtilReadView.vue"
          ),
        props: true,
        meta: {
          title: "Util Info",
          permission: 46,
        },
      },
      {
        path: "utils/:uuid/edit",
        name: "UtilEditView",
        component: () =>
          import(
            /* webpackChunkName: "utils-edit-view" */ "@/views/user/UtilEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Util",
          permission: 47,
        },
      },
      {
        path: "reviews",
        name: "ReviewBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "reviews-browse-view" */ "@/views/user/ReviewBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Reviews",
          permission: 50,
        },
      },
      {
        path: "reviews/new",
        name: "ReviewAddView",
        component: () =>
          import(
            /* webpackChunkName: "reviews-add-view" */ "@/views/user/ReviewAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Review",
          permission: 48,
        },
      },
      {
        path: "reviews/:uuid",
        name: "ReviewReadView",
        component: () =>
          import(
            /* webpackChunkName: "reviews-read-view" */ "@/views/user/ReviewReadView.vue"
          ),
        props: true,
        meta: {
          title: "Review Info",
          permission: 50,
        },
      },
      {
        path: "reviews/:uuid/edit",
        name: "ReviewEditView",
        component: () =>
          import(
            /* webpackChunkName: "reviews-edit-view" */ "@/views/user/ReviewEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Review",
          permission: 51,
        },
      },
      {
        path: "reviews/:uuid/delete",
        name: "ReviewDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "reviews-delete-view" */ "@/views/user/ReviewDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Review",
          permission: 52,
        },
      },
      {
        path: "roles",
        name: "RoleBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "roles-browse-view" */ "@/views/user/RoleBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Roles",
          permission: 14,
        },
      },
      {
        path: "roles/new",
        name: "RoleAddView",
        component: () =>
          import(
            /* webpackChunkName: "roles-add-view" */ "@/views/user/RoleAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Role",
          permission: 13,
        },
      },
      {
        path: "roles/:uuid",
        name: "RoleReadView",
        component: () =>
          import(
            /* webpackChunkName: "roles-read-view" */ "@/views/user/RoleReadView.vue"
          ),
        props: true,
        meta: {
          title: "Role Info",
          permission: 14,
        },
      },
      {
        path: "roles/:uuid/edit",
        name: "RoleEditView",
        component: () =>
          import(
            /* webpackChunkName: "roles-edit-view" */ "@/views/user/RoleEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Role",
          permission: 15,
        },
      },
      {
        path: "roles/:uuid/delete",
        name: "RoleDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "roles-delete-view" */ "@/views/user/RoleDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Role",
          permission: 16,
        },
      },
      {
        path: "logout",
        name: "LogoutView",
        component: () =>
          import(
            /* webpackChunkName: "logout-view" */ "@/views/LogoutView.vue"
          ),
        props: true,
      },
    ],
  },
  {
    path: "/",
    component: LayoutMain,
    children: [
      {
        path: "booking/:location",
        name: "CustomerBookingView",
        component: () =>
          import(
            /* webpackChunkName: "customer-booking-view" */ "@/views/CustomerBookingView.vue"
          ),
        props: true,
        meta: {
          title: "Booking",
        },
      },
      {
        path: "/:catchAll(.*)",
        name: "ErrorNotFoundView",
        component: () =>
          import(
            /* webpackChunkName: "not-found-view" */ "@/views/error/ErrorNotFoundView.vue"
          ),
        props: true,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved position (e.g., navigating back), use it
    if (savedPosition) {
      return savedPosition;
    }
    // Otherwise, scroll to the top
    return { x: 0, y: 0 };
  },
});
router.beforeEach((to, from, next) => {
  // Retrieve user's access codes
  const permissions =
    store.state.account && store.state.account.data
      ? store.state.account.data.permissions
      : [];

  // Check if the route requires a permission
  if (to.meta.permission) {
    if (permissions.includes(to.meta.permission)) {
      // User has permission
      return next();
    } else {
      // User does not have permission
      return next({ name: "ErrorNotFoundView" });
    }
  }
  // If route doesn't require a permission, proceed normally
  return next();
});
router.afterEach((to) => {
  //BOC:[page title]
  Vue.nextTick(() => {
    document.title = to.meta.title
      ? to.meta.title + " | Tapes To Digital"
      : "Tapes To Digital";
  });
  //EOC
});

export default router;
